<template>
  <body>
    <aside class="Blk-1">
    </aside>
    <aside class="Blk-2">
      <div v-if="loading" class="loader">
      </div>
      <div v-else>
        <article class="Form">
          <div class="Columna1">
            <div class="titulo1">
              <h4 id="top">Colecciones</h4>
            </div>
            <div class="titulo2">
              <div class="t21">Libros</div>
              <div class="t22">{{totales.libros}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Publicaciones periódicas</div>
              <div class="t22">{{totales.pubpers}}</div>
            </div>
            <div class="titulo3">
              <div class="t23">Ediciones periódicas</div>
              <div class="t22">{{totales.edipers}}</div>
            </div>
            <div class="titulo4">
              <div class="t24">Artículos</div>
              <div class="t22">{{totales.separatas}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Congresos</div>
              <div class="t22">{{totales.congresos}}</div>
            </div>
            <div class="titulo3">
              <div class="t23">Resúmenes de ponencias</div>
              <div class="t22">{{totales.ponencias}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Literatura gris</div>
              <div class="t22">{{totales.tesisies}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Hemerografías</div>
              <div class="t22">{{totales.hemeros}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Separatas</div>
              <div class="t22">{{totales.separatas}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Sellos</div>
              <div class="t22">{{totales.sellos}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Postales</div>
              <div class="t22">{{totales.postals}}</div>
            </div>
            <div class="titulo2">
              <div class="t21">Misceláneos</div>
              <div class="t22">{{totales.miscels}}</div>
            </div>
          </div>
          <div class="Columna1">
            <div class="titulo1">
              <h4 class="Col2">Catastro</h4>
            </div>
            <div class="titulo2">
              <div class="t21">Cuevas registradas</div>
              <div class="t22">{{totales.cuevas}}</div>
            </div>
            <div class="titulo1">
              <h4> </h4>
            </div>
            <div class="titulo1">
              <h4>Glosario</h4>
            </div>
            <div class="titulo2">
              <div class="t21">Palabras registradas</div>
              <div class="t22">{{totales.palabras}}</div>
            </div>
            <div class="titulo1">
              <h4> </h4>
            </div>
            <div class="titulo1">
              <h4>Autores</h4>
            </div>
            <div class="titulo2">
              <div class="t21">Autores registrados</div>
              <div class="t22">{{totales.autors}}</div>
            </div>
          </div>
        </article>
      </div>
      <aside class="Btns">

      </aside>
    </aside>
  </body>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  name: 'FormDatCatalogo',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.buscaDatosCat()
  },
  data () {
    return {
      usuarioSel: [],
      usuarioSelBkUp: [],
      tipoUsuario: '',
      totales: {},
      loading: false,

      URLbase: ''
    }
  },
  methods: {
    buscaDatosCat () {
      try {
        this.loading = true
        const url = `${this.URLbase}/resumen/totalRegistrosPorColeccion`
        axios.get(url, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            const totales = result.data
            this.totales = totales
            console.log(totales)
            this.loading = false
            setTimeout(() => {
              // const topElement = document.getElementById('top')
              // topElement.scrollIntoView()
              console.log('Top')
            }, 500)
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      } catch (error) {
        alert(error)
        this.loading = false
      }
    }

  },
  computed: {
    ...mapState(['usuarioEnSesion']),
    sesion () {
      return (this.usuarioEnSesion.nombre === undefined)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article {
  /* color: darkslategray; */
  padding-top: 30px;
  display: grid;
  grid-template-columns: 50% 50%;
}
.Columna1 {
  /* border: solid 0.5px rgb(183, 248, 3); */
}
.titulo1{
  font-size: 17px;
  text-align: left;
  color: rgb(41, 155, 248);
  padding-left: 18px;
  height: 20px;
}
.titulo2 {
  display: grid;
  grid-template-columns: 80% 20%;
  color: black;
  width: 70%;
  padding-left: 18px;
  padding-bottom: 7px;
  padding-top: 5px;
  text-align: left;
  font-weight: bold;
  margin-left:25px;
}
.titulo3{
  display: grid;
  grid-template-columns: 80% 20%;
  text-align: left;
  color: black;
  width: 70%;
  padding-left: 18px;
  padding-bottom: 12px;
  height: 20px;
  margin-left: 25px;
}
.titulo4{
  display: grid;
  grid-template-columns: 80% 20%;
  text-align: left;
  color: black;
  width: 70%;
  padding-left: 18px;
  padding-bottom: 12px;
  height: 20px;
  margin-left: 25px;
}
.titulo3 .t23 {
  margin-left: 30px;
  border-bottom: solid 0.5px rgb(253, 251, 251);
}
.titulo4 .t24 {
  margin-left: 60px;
  border-bottom: solid 0.5px rgb(253, 251, 251);
}
.t21{
  /* border: solid 0.5px rgb(183, 248, 3); */
  text-align: left;
  border-bottom: solid 0.5px rgb(253, 251, 251);
}
.t22{
  /* border: solid 0.5px rgb(183, 248, 3); */
  text-align: right;
  border-bottom: solid 0.5px rgb(253, 251, 251);
}

.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  position: sticky; /* no funciona */
}

.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}

.loader {
  /* border: 4px solid #f3f3f3; /* Light grey */
  border: 4px solid transparent;
  /* border-top: 4px solid #3498db; /* Blue */
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 600px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  article{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* border: solid 0.5px rgb(183, 248, 3); */
    /* align-items: stretch; */
  }
  .Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Columna1{
    width: 100%;
  }
  .Col2{
    margin-top: 20px;
  }
  .titulo1{
    padding-left: 30px;
  }
  .titulo2{
    width: 75%;
  }
  .titulo3{
    width: 75%;
  }
  .titulo4{
    width: 75%;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
}
</style>
